module.exports = __webpack_public_path__ + "static/media/slack-mark.b0b0f4a4.png";